var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalloonLogo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 101,
    viewBox: "0 0 269 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 68,
    width: 5,
    height: 5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.057 70.4517C120.057 71.6543 120.959 72.5562 122.161 72.5562C123.364 72.5562 124.266 71.6543 124.266 70.4517C124.266 69.2491 123.364 68.3472 122.161 68.3472C120.959 68.3472 120.057 69.2491 120.057 70.4517Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.114 68.3472H120.056V72.4059H124.114V68.3472Z",
    fill: "url(#paint0_linear_540_9619)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 68,
    width: 5,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.669 70.9031C126.669 72.1057 127.571 73.0076 128.774 73.0076C129.976 73.0076 130.878 72.1057 130.878 70.9031C130.878 69.7005 129.976 68.7985 128.774 68.7985C127.571 68.6482 126.669 69.7005 126.669 70.9031Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.028 68.6479H126.669V73.0073H131.028V68.6479Z",
    fill: "url(#paint1_linear_540_9619)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 71,
    width: 6,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.833 73.7589C132.833 74.9615 133.885 76.0138 135.088 76.0138C136.29 76.0138 137.343 74.9615 137.343 73.7589C137.343 72.5563 136.29 71.5041 135.088 71.5041C133.885 71.3537 132.833 72.406 132.833 73.7589Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.343 71.354H132.833V75.8637H137.343V71.354Z",
    fill: "url(#paint2_linear_540_9619)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 75,
    width: 6,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.695 77.8173C138.695 79.1702 139.748 80.2224 141.101 80.2224C142.453 80.2224 143.506 79.1702 143.506 77.8173C143.506 76.4643 142.453 75.4121 141.101 75.4121C139.898 75.4121 138.695 76.4643 138.695 77.8173Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.506 75.4121H138.695V80.2224H143.506V75.4121Z",
    fill: "url(#paint3_linear_540_9619)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 75,
    width: 6,
    height: 6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.062 77.6673C146.062 79.0203 147.114 80.2228 148.617 80.2228C150.12 80.2228 151.173 79.1706 151.173 77.6673C151.173 76.3144 150.12 75.1118 148.617 75.1118C147.114 75.1118 146.062 76.3144 146.062 77.6673Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.022 75.1118H146.062V80.0725H151.022V75.1118Z",
    fill: "url(#paint4_linear_540_9619)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 71,
    width: 6,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.676 74.0599C152.676 75.5631 153.878 76.6154 155.231 76.6154C156.734 76.6154 157.787 75.4128 157.787 74.0599C157.787 72.5566 156.584 71.5044 155.231 71.5044C153.878 71.5044 152.676 72.707 152.676 74.0599Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.937 71.5044H152.676V76.7657H157.937V71.5044Z",
    fill: "url(#paint5_linear_540_9619)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 160,
    y: 68,
    width: 6,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.192 71.053C160.192 72.5562 161.395 73.7588 162.898 73.7588C164.401 73.7588 165.604 72.5562 165.604 71.053C165.604 69.5497 164.401 68.3472 162.898 68.3472C161.395 68.3472 160.192 69.5497 160.192 71.053Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.604 68.3472H160.192V73.7588H165.604V68.3472Z",
    fill: "url(#paint6_linear_540_9619)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 70,
    width: 7,
    height: 7
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.858 73.3078C167.858 74.811 169.211 76.164 170.715 76.164C172.218 76.164 173.571 74.811 173.571 73.3078C173.571 71.8046 172.218 70.4517 170.715 70.4517C169.211 70.4517 167.858 71.6542 167.858 73.3078Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.571 70.4517H167.858V76.164H173.571V70.4517Z",
    fill: "url(#paint7_linear_540_9619)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 74,
    width: 7,
    height: 7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175.074 77.3668C175.074 79.0204 176.427 80.3733 178.081 80.3733C179.734 80.3733 181.087 79.0204 181.087 77.3668C181.087 75.7133 179.734 74.3604 178.081 74.3604C176.427 74.5107 175.074 75.7133 175.074 77.3668Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.937 74.5112H175.074V80.3739H180.937V74.5112Z",
    fill: "url(#paint8_linear_540_9619)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 70,
    width: 7,
    height: 7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182.74 73.6082C182.74 75.2618 184.093 76.6147 185.747 76.6147C187.4 76.6147 188.753 75.2618 188.753 73.6082C188.753 71.9547 187.4 70.6017 185.747 70.6017C184.093 70.4514 182.74 71.8043 182.74 73.6082Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.903 70.4517H182.74V76.615H188.903V70.4517Z",
    fill: "url(#paint9_linear_540_9619)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_540_9619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 62,
    width: 7,
    height: 7
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.048 65.4913C186.048 67.2952 187.551 68.6481 189.205 68.6481C191.009 68.6481 192.361 67.1448 192.361 65.4913C192.361 63.6874 190.858 62.3345 189.205 62.3345C187.551 62.3345 186.048 63.6874 186.048 65.4913Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_540_9619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.361 62.3345H186.048V68.7984H192.361V62.3345Z",
    fill: "url(#paint10_linear_540_9619)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60013 54.0662C2.95304 54.9682 5.35819 55.8701 7.76337 55.8701C11.2208 55.8701 12.724 54.2166 12.724 52.112C12.724 49.8572 11.3711 48.6546 7.91366 47.452C3.25362 45.7984 1.14908 43.2429 1.14908 40.2364C1.14908 36.0273 4.45624 32.7202 10.0182 32.7202C12.5737 32.7202 14.9789 33.4718 16.3319 34.3738L15.1293 37.8313C14.077 37.23 12.2731 36.328 9.86794 36.328C7.16211 36.328 5.50851 37.9816 5.50851 39.7855C5.50851 41.89 7.01173 42.9423 10.4692 44.1448C14.9789 45.7984 17.2338 48.0533 17.2338 51.9617C17.2338 56.4714 13.7764 59.7785 7.61308 59.7785C4.75693 59.7785 2.20135 59.0269 0.397461 57.9747L1.60013 54.0662Z",
    fill: "#7F8081"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5858 57.8251C40.3832 58.4264 37.6774 59.3284 34.2199 59.3284C26.4031 59.3284 21.4424 54.0671 21.4424 46.0999C21.4424 38.1327 26.8541 32.4204 35.2722 32.4204C37.978 32.4204 40.5335 33.172 41.7361 33.7733L40.6839 37.3811C39.6317 36.7798 37.8277 36.1785 35.2722 36.1785C29.4096 36.1785 26.1025 40.5379 26.1025 45.9496C26.1025 51.9625 29.8605 55.5703 34.9715 55.5703C37.6774 55.5703 39.331 54.8187 40.6839 54.3677L41.5858 57.8251Z",
    fill: "#7F8081"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.704 46.099C49.704 51.661 53.0111 56.0203 57.5208 56.0203C62.0305 56.0203 65.3377 51.8113 65.3377 45.9486C65.3377 41.5893 63.0829 36.0273 57.6712 36.0273C52.1092 36.0273 49.704 41.1383 49.704 46.099ZM70.1481 45.7983C70.1481 55.2687 63.5338 59.4778 57.3705 59.4778C50.4556 59.4778 45.0439 54.3668 45.0439 46.2493C45.0439 37.6808 50.6059 32.5698 57.8215 32.5698C65.037 32.5698 70.1481 37.8311 70.1481 45.7983Z",
    fill: "#7F8081"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0107 41.7398C76.0107 38.7333 76.0107 36.0275 75.8604 33.7727H79.9191L80.0694 38.8837H80.2198C81.4224 35.4262 84.2785 33.1714 87.285 33.1714C87.8863 33.1714 88.1869 33.1714 88.6379 33.3217V37.6811C88.1869 37.5308 87.736 37.5308 86.9844 37.5308C83.6772 37.5308 81.4224 40.0863 80.6707 43.5437C80.5204 44.145 80.5204 44.8966 80.5204 45.7986V59.4781H75.8604V41.7398H76.0107Z",
    fill: "#7F8081"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.232 43.5444C109.232 40.5379 108.03 35.8778 102.768 35.8778C97.9578 35.8778 96.0036 40.2372 95.5527 43.5444H109.232ZM95.4023 46.8515C95.5526 53.1651 99.6114 55.7206 104.271 55.7206C107.579 55.7206 109.683 55.1193 111.337 54.3677L112.088 57.6748C110.435 58.4264 107.579 59.3284 103.52 59.3284C95.5527 59.3284 90.8926 54.067 90.8926 46.2502C90.8926 38.4333 95.4023 32.4204 102.918 32.4204C111.337 32.4204 113.592 39.7863 113.592 44.5967C113.592 45.4986 113.441 46.2502 113.441 46.8515H95.4023Z",
    fill: "#7F8081"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M195.067 34.3739H194.015V34.0732H196.871V34.3739H195.668V37.8313H195.067V34.3739Z",
    fill: "#939639"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M200.478 36.1778C200.478 35.5765 200.478 34.9752 200.478 34.5242C200.328 34.9752 200.178 35.4261 200.027 36.0274L199.426 37.8313H198.975L198.374 36.0274C198.223 35.4261 198.073 34.9752 197.923 34.5242C197.923 34.9752 197.923 35.5765 197.923 36.1778L197.772 37.8313H197.321L197.622 34.0732H198.223L198.825 35.8771C198.975 36.3281 199.125 36.779 199.276 37.23C199.426 36.779 199.576 36.4784 199.727 35.8771L200.478 34.0732H201.079L201.38 37.8313H200.929L200.478 36.1778Z",
    fill: "#939639"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.905 59.4778V37.5305H116.297V34.0731H119.905V32.8705C119.905 29.2627 120.656 26.1059 122.911 24.0014C124.715 22.3478 126.97 21.5962 129.074 21.5962C130.728 21.5962 132.081 21.8968 132.983 22.3478L132.382 25.9556C131.63 25.6549 130.728 25.3543 129.375 25.3543C125.467 25.3543 124.414 28.8117 124.414 32.7202V34.0731H130.578V37.5305H124.414V59.4778H119.905Z",
    fill: "#939639"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M141.251 22.0469H136.591V59.3272H141.251V22.0469Z",
    fill: "#939639"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M162.597 43.6939C162.597 40.6875 161.394 36.1778 156.133 36.1778C151.473 36.1778 149.368 40.5371 149.067 43.6939H162.597ZM149.067 47.001C149.218 53.3147 153.126 55.8702 157.786 55.8702C161.093 55.8702 163.048 55.2689 164.851 54.5172L165.603 57.8244C163.95 58.576 161.244 59.478 157.185 59.478C149.368 59.478 144.708 54.2166 144.708 46.5501C144.708 38.8836 149.218 32.8706 156.584 32.8706C164.851 32.8706 167.106 40.2365 167.106 44.8965C167.106 45.7985 166.956 46.5501 166.956 47.001H149.067Z",
    fill: "#939639"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M174.773 33.9233L178.381 39.335C179.283 40.6879 180.185 42.0408 180.936 43.5441H181.086C181.988 42.0408 182.74 40.6879 183.642 39.335L187.25 33.9233H192.21L183.492 46.2499L192.361 59.3281H187.099L183.341 53.6158C182.289 52.1125 181.537 50.7596 180.636 49.2564H180.485C179.583 50.7596 178.681 52.1125 177.779 53.6158L174.172 59.3281H169.061L178.08 46.4002L169.512 33.9233H174.773Z",
    fill: "#939639"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M266.471 51.0598C266.471 67.7458 252.942 81.275 236.256 81.275C219.57 81.275 206.041 67.7458 206.041 51.0598C206.041 34.3739 219.57 20.8447 236.256 20.8447C253.092 20.9951 266.471 34.5242 266.471 51.0598Z",
    fill: "#923854"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M217.766 45.4979V58.2754H216.413V43.9946H220.923L233.7 56.7722V43.9946H235.204V58.2754H229.942L217.766 45.4979Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M244.222 58.2753C243.621 58.2753 243.02 58.125 242.419 57.9747C241.817 57.8244 241.366 57.5237 240.765 57.2231C240.314 56.9224 239.863 56.6217 239.412 56.1708C238.961 55.7198 238.661 55.2688 238.36 54.6675C238.059 54.2166 237.909 53.6153 237.608 53.014C237.458 52.4127 237.308 51.8114 237.308 51.0598C237.308 50.4585 237.458 49.7069 237.608 49.1056C237.759 48.5043 238.059 47.903 238.36 47.452C238.661 46.8507 238.961 46.3997 239.412 45.9488C239.863 45.4978 240.314 45.1971 240.765 44.8965C241.216 44.5958 241.817 44.2952 242.419 44.1449C243.02 43.9945 243.621 43.8442 244.222 43.8442H256.399V45.1971H246.928C246.177 45.1971 245.425 45.3475 244.824 45.6481C244.223 45.9487 243.621 46.3997 243.02 46.8507C242.569 47.3017 242.118 48.0533 241.817 48.6546C241.517 49.4062 241.366 50.1578 241.366 50.9094C241.366 51.6611 241.517 52.4127 241.817 53.1643C242.118 53.9159 242.569 54.5172 243.02 54.9682C243.471 55.4192 244.072 55.8701 244.824 56.1708C245.425 56.4714 246.177 56.6218 246.928 56.6218H256.399V57.9747H244.222V58.2753Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40384 69.3992C3.25351 68.9483 2.95288 68.4973 2.20126 68.4973C1.29932 68.4973 0.848403 68.9483 0.848403 70.0005C0.848403 70.7521 1.149 71.3534 2.20126 71.3534C2.80256 71.3534 3.25351 71.0528 3.40384 70.3011H4.00517C3.85484 71.0528 3.25353 71.8044 2.20126 71.8044C1.29932 71.8044 0.24707 71.3534 0.24707 69.8502C0.24707 68.7979 0.848348 67.896 2.20126 67.896C2.95288 67.896 3.85484 68.1966 4.00517 69.2489H3.40384V69.3992Z",
    fill: "#7F8081"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31281 69.3992C6.56119 69.3992 6.26052 69.8502 6.26052 70.4515C6.26052 70.9025 6.56119 71.5038 7.31281 71.5038C8.06443 71.5038 8.3651 71.0528 8.3651 70.4515C8.3651 69.8502 8.06443 69.3992 7.31281 69.3992ZM7.31281 68.9482C8.36508 68.9482 8.81605 69.5495 8.81605 70.3011C8.81605 71.0528 8.36508 71.6541 7.31281 71.6541C6.26054 71.6541 5.80957 71.0528 5.80957 70.3011C5.80957 69.5495 6.26054 68.9482 7.31281 68.9482Z",
    fill: "#7F8081"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7695 69.0986H11.2205V69.5495C11.5211 69.0986 11.8218 68.9482 12.1225 68.9482C12.2728 68.9482 12.2727 68.9482 12.4231 68.9482V69.5495C12.2727 69.5495 12.2728 69.5495 12.1225 69.5495C11.6715 69.5495 11.2205 69.8502 11.2205 70.4515V71.8044H10.7695V69.0986Z",
    fill: "#7F8081"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5804 69.3992C14.8288 69.3992 14.5281 69.8502 14.5281 70.4515C14.5281 70.9025 14.8288 71.5038 15.5804 71.5038C16.332 71.5038 16.6327 71.0528 16.6327 70.4515C16.6327 69.8502 16.332 69.3992 15.5804 69.3992ZM15.5804 68.9482C16.6327 68.9482 17.0836 69.5495 17.0836 70.3011C17.0836 71.0528 16.6327 71.6541 15.5804 71.6541C14.5281 71.6541 14.0771 71.0528 14.0771 70.3011C14.0771 69.5495 14.6784 68.9482 15.5804 68.9482Z",
    fill: "#7F8081"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0371 69.0991H19.4881V69.5501C19.7887 69.2494 20.0894 69.0991 20.5403 69.0991C21.1416 69.0991 21.5926 69.3998 21.5926 70.0011V71.8049H21.1417V70.1514C21.1417 69.7004 20.841 69.5501 20.3901 69.5501C19.9391 69.5501 19.4881 69.8507 19.4881 70.3017V71.8049H19.0371V69.0991Z",
    fill: "#7F8081"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8017 70.3011C25.8017 70.4515 25.6514 70.4515 25.3508 70.4515H24.7494C24.2985 70.4515 24.1482 70.6018 24.1482 70.9025C24.1482 71.2031 24.4488 71.3534 24.7494 71.3534C25.3507 71.3534 25.8017 71.0528 25.8017 70.6018V70.3011ZM23.6972 69.8502C23.6972 69.2489 24.1482 68.9482 25.0501 68.9482C25.6514 68.9482 26.2527 69.0986 26.2527 69.6999V71.0528C26.2527 71.2031 26.2527 71.3534 26.4031 71.3534H26.5534V71.6541C26.403 71.6541 26.2527 71.6541 26.1024 71.6541C25.8018 71.6541 25.6514 71.6541 25.6514 71.3534C25.5011 71.6541 24.8998 71.8044 24.5992 71.8044C23.6972 71.8044 23.5469 71.3534 23.5469 71.0528C23.5469 70.6018 23.8475 70.3011 24.7494 70.3011H25.3508C25.6514 70.3011 25.8017 70.1509 25.8017 70.0005C25.8017 69.6999 25.5011 69.5495 25.0501 69.5495C24.5991 69.5495 24.2985 69.6999 24.2985 70.0005H23.6972V69.8502Z",
    fill: "#7F8081"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5078 69.0986H28.9588V69.5495C29.2594 69.0986 29.5601 68.9482 29.8608 68.9482C30.0111 68.9482 30.0111 68.9482 30.1614 68.9482V69.5495C30.0111 69.5495 30.0111 69.5495 29.8608 69.5495C29.4098 69.5495 28.9588 69.8502 28.9588 70.4515V71.8044H28.5078V69.0986Z",
    fill: "#7F8081"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9199 69.0986H34.5211L33.1683 72.2554C32.8676 72.8567 32.7173 72.8567 32.2663 72.8567C32.116 72.8567 31.9657 72.8567 31.8153 72.8567V72.4057C31.9657 72.4057 31.9657 72.4057 32.116 72.4057C32.4166 72.4057 32.5669 72.4057 32.7172 71.9547L32.8676 71.6541L31.665 68.9482H32.2663L33.1683 71.0528L33.9199 69.0986Z",
    fill: "#7F8081"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2852 71.2032C42.1872 71.2032 42.3375 70.4516 42.3375 69.8503C42.3375 69.249 42.1872 68.4974 41.135 68.4974H39.9324V71.2032H41.2852ZM39.3311 68.0464H41.135C42.1872 68.0464 42.6382 68.798 42.6382 69.8503C42.6382 70.9026 42.1872 71.6542 41.135 71.6542H39.3311V68.0464Z",
    fill: "#7F8081"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7432 69.0987H45.1942V71.8045H44.7432V69.0987ZM44.7432 68.0464H45.1942V68.6477H44.7432V68.0464Z",
    fill: "#7F8081"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7498 68.0464H47.2988V71.6542H47.7498V68.0464Z",
    fill: "#7F8081"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8087 70.3011C51.6584 70.4515 51.6584 70.4515 51.3577 70.4515H50.7564C50.3054 70.4515 50.1552 70.6018 50.1552 70.9025C50.1552 71.2031 50.4558 71.3534 50.7564 71.3534C51.3577 71.3534 51.8087 71.0528 51.8087 70.6018V70.3011ZM49.8545 69.8502C49.8545 69.2489 50.3055 68.9482 51.2074 68.9482C51.8087 68.9482 52.41 69.0986 52.41 69.6999V71.0528C52.41 71.2031 52.41 71.3534 52.7107 71.3534H52.861V71.6541C52.7106 71.6541 52.5603 71.6541 52.41 71.6541C52.1094 71.6541 51.9591 71.6541 51.9591 71.3534C51.8087 71.6541 51.2074 71.8044 50.9068 71.8044C50.0048 71.8044 49.8545 71.3534 49.8545 71.0528C49.8545 70.6018 50.1551 70.3011 51.0571 70.3011H51.6584C51.959 70.3011 52.1094 70.1509 52.1094 70.0005C52.1094 69.6999 51.8087 69.5495 51.3577 69.5495C50.9068 69.5495 50.6061 69.6999 50.6061 70.0005H49.8545V69.8502Z",
    fill: "#7F8081"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6637 68.1968H55.1147V68.9484H55.8663V69.3994H55.1147V71.0529C55.1147 71.2032 55.265 71.3536 55.5656 71.3536C55.716 71.3536 55.8663 71.3536 55.8663 71.3536V71.8045C55.716 71.8045 55.5656 71.8045 55.265 71.8045C54.814 71.8045 54.5134 71.5039 54.5134 71.2033V69.5497H53.9121V69.0987H54.5134V68.1968H54.6637Z",
    fill: "#7F8081"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7754 70.3011C59.6251 70.4515 59.6251 70.4515 59.3244 70.4515H58.7232C58.2722 70.4515 58.1219 70.6018 58.1219 70.9025C58.1219 71.2031 58.4225 71.3534 58.7232 71.3534C59.3245 71.3534 59.7754 71.0528 59.7754 70.6018V70.3011ZM57.6709 69.8502C57.6709 69.2489 58.1218 68.9482 59.0238 68.9482C59.6251 68.9482 60.2264 69.0986 60.2264 69.6999V71.0528C60.2264 71.2031 60.2264 71.3534 60.527 71.3534H60.6774V71.6541C60.5271 71.6541 60.3767 71.6541 60.2264 71.6541C59.9258 71.6541 59.7754 71.6541 59.7754 71.3534C59.6251 71.6541 59.0238 71.8044 58.7232 71.8044C57.8212 71.8044 57.6709 71.3534 57.6709 71.0528C57.6709 70.6018 57.9715 70.3011 58.8735 70.3011H59.4748C59.7755 70.3011 59.9258 70.1509 59.9258 70.0005C59.9258 69.6999 59.6251 69.5495 59.1741 69.5495C58.7232 69.5495 58.4225 69.6999 58.4225 70.0005H57.6709V69.8502Z",
    fill: "#7F8081"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6315 68.1968H63.0825V68.9484H63.8341V69.3994H63.0825V71.0529C63.0825 71.2032 63.2328 71.3536 63.5334 71.3536C63.6837 71.3536 63.8341 71.3536 63.8341 71.3536V71.8045C63.6838 71.8045 63.5335 71.8045 63.2328 71.8045C62.7819 71.8045 62.4812 71.5039 62.4812 71.2033V69.5497H61.8799V69.0987H62.4812V68.1968H62.6315Z",
    fill: "#7F8081"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6377 69.0987H66.0886V71.8045H65.6377V69.0987ZM65.6377 68.0464H66.0886V68.6477H65.6377V68.0464Z",
    fill: "#7F8081"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M69.696 69.3992C68.9444 69.3992 68.6437 69.8502 68.6437 70.4515C68.6437 70.9025 68.9444 71.5038 69.696 71.5038C70.4476 71.5038 70.7483 71.0528 70.7483 70.4515C70.598 69.8502 70.4476 69.3992 69.696 69.3992ZM69.696 68.9482C70.7483 68.9482 71.1993 69.5495 71.1993 70.3011C71.1993 71.0528 70.7483 71.6541 69.696 71.6541C68.6438 71.6541 68.1928 71.0528 68.1928 70.3011C68.0425 69.5495 68.6438 68.9482 69.696 68.9482Z",
    fill: "#7F8081"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1543 69.0991H73.6053V69.5501C73.9059 69.2494 74.2066 69.0991 74.6575 69.0991C75.2588 69.0991 75.7098 69.3998 75.7098 70.0011V71.8049H75.2589V70.1514C75.2589 69.7004 74.9582 69.5501 74.5072 69.5501C74.0563 69.5501 73.6053 69.8507 73.6053 70.3017V71.8049H73.1543V69.0991Z",
    fill: "#7F8081"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9772 69.3992C83.8268 68.9483 83.5262 68.4973 82.7746 68.4973C81.8727 68.4973 81.4216 68.9483 81.4216 70.0005C81.4216 70.7521 81.7223 71.3534 82.7746 71.3534C83.3759 71.3534 83.8268 71.0528 83.9772 70.3011H84.5784C84.4281 71.0528 83.8269 71.8044 82.7746 71.8044C81.8727 71.8044 80.8203 71.3534 80.8203 69.8502C80.8203 68.7979 81.4217 67.896 82.7746 67.896C83.5262 67.896 84.4281 68.1966 84.5784 69.2489H83.9772V69.3992Z",
    fill: "#7F8081"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4874 70.3011C88.3371 70.4515 88.3371 70.4515 88.0364 70.4515H87.4351C86.9841 70.4515 86.8338 70.6018 86.8338 70.9025C86.8338 71.2031 87.1345 71.3534 87.4351 71.3534C88.0364 71.3534 88.4874 71.0528 88.4874 70.6018V70.3011ZM86.3828 69.8502C86.3828 69.2489 86.8338 68.9482 87.7358 68.9482C88.3371 68.9482 88.9383 69.0986 88.9383 69.6999V71.0528C88.9383 71.2031 88.9384 71.3534 89.239 71.3534H89.3893V71.6541C89.239 71.6541 89.0887 71.6541 88.9383 71.6541C88.6377 71.6541 88.4874 71.6541 88.4874 71.3534C88.3371 71.6541 87.7357 71.8044 87.4351 71.8044C86.5332 71.8044 86.3828 71.3534 86.3828 71.0528C86.3828 70.6018 86.6834 70.3011 87.5854 70.3011H88.1867C88.4874 70.3011 88.6377 70.1509 88.6377 70.0005C88.6377 69.6999 88.337 69.5495 87.8861 69.5495C87.4351 69.5495 87.1344 69.6999 87.1344 70.0005H86.3828V69.8502Z",
    fill: "#7F8081"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3434 68.1968H91.7945V68.9484H92.5461V69.3994H91.7945V71.0529C91.7945 71.2032 91.9448 71.3536 92.2454 71.3536C92.3957 71.3536 92.5461 71.3536 92.5461 71.3536V71.8045C92.3958 71.8045 92.2454 71.8045 91.9447 71.8045C91.4938 71.8045 91.1931 71.5039 91.1931 71.2033V69.5497H90.5918V69.0987H91.1931V68.1968H91.3434Z",
    fill: "#7F8081"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3496 68.0464H94.8007V69.3993C95.1013 69.0987 95.4019 68.9483 95.8528 68.9483C96.4541 68.9483 96.9051 69.249 96.9051 69.8503V71.6542H96.4542V70.0006C96.4542 69.5497 96.1535 69.3993 95.7026 69.3993C95.2516 69.3993 94.8007 69.7 94.8007 70.151V71.6542H94.3496V68.0464Z",
    fill: "#7F8081"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M101.265 70.1514C101.265 69.7004 100.814 69.3998 100.363 69.3998C99.9117 69.3998 99.4607 69.7004 99.4607 70.1514H101.265ZM99.4607 70.452C99.4607 71.0533 99.9117 71.354 100.363 71.354C100.663 71.354 101.114 71.2037 101.265 70.903H101.866C101.565 71.5043 100.964 71.8049 100.513 71.8049C99.4607 71.8049 99.0098 71.2036 99.0098 70.452C99.0098 69.7004 99.4607 69.0991 100.513 69.0991C101.265 69.0991 102.016 69.5501 102.016 70.6024H99.4607V70.452Z",
    fill: "#7F8081"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M103.97 68.1968H104.421V68.9484H105.173V69.3994H104.421V71.0529C104.421 71.2032 104.572 71.3536 104.872 71.3536C105.023 71.3536 105.173 71.3536 105.173 71.3536V71.8045C105.023 71.8045 104.872 71.8045 104.572 71.8045C104.121 71.8045 103.82 71.5039 103.82 71.2033V69.5497H103.219V69.0987H103.82V68.1968H103.97Z",
    fill: "#7F8081"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M109.382 70.1514C109.382 69.7004 108.931 69.3998 108.48 69.3998C108.029 69.3998 107.578 69.7004 107.578 70.1514H109.382ZM107.428 70.452C107.428 71.0533 107.879 71.354 108.33 71.354C108.63 71.354 109.081 71.2037 109.231 70.903H109.833C109.532 71.5043 108.931 71.8049 108.48 71.8049C107.428 71.8049 106.977 71.2036 106.977 70.452C106.977 69.7004 107.428 69.0991 108.48 69.0991C109.231 69.0991 109.983 69.5501 109.983 70.6024H107.428V70.452Z",
    fill: "#7F8081"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M111.787 69.0986H112.238V69.5495C112.539 69.0986 112.839 68.9482 113.14 68.9482C113.29 68.9482 113.29 68.9482 113.441 68.9482V69.5495C113.29 69.5495 113.29 69.5495 113.14 69.5495C112.689 69.5495 112.238 69.8502 112.238 70.4515V71.8044H111.787V69.0986Z",
    fill: "#7F8081"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_540_9619",
    x1: 122.36,
    y1: 70.384,
    x2: 188.496,
    y2: 70.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_540_9619",
    x1: 122.247,
    y1: 70.8615,
    x2: 188.41,
    y2: 70.8615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_540_9619",
    x1: 122.323,
    y1: 73.7121,
    x2: 188.509,
    y2: 73.7121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_540_9619",
    x1: 122.237,
    y1: 77.8183,
    x2: 188.897,
    y2: 77.8183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_540_9619",
    x1: 122.218,
    y1: 77.6625,
    x2: 188.877,
    y2: 77.6625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_540_9619",
    x1: 122.133,
    y1: 74.1364,
    x2: 188.792,
    y2: 74.1364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_540_9619",
    x1: 122.421,
    y1: 71.098,
    x2: 188.697,
    y2: 71.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_540_9619",
    x1: 122.251,
    y1: 73.2491,
    x2: 188.922,
    y2: 73.2491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_540_9619",
    x1: 122.479,
    y1: 77.4187,
    x2: 188.775,
    y2: 77.4187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_540_9619",
    x1: 122.438,
    y1: 73.5871,
    x2: 188.746,
    y2: 73.5871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_540_9619",
    x1: 122.431,
    y1: 65.4923,
    x2: 188.752,
    y2: 65.4923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#93953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5076,
    stopColor: "#93903C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#938940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7228,
    stopColor: "#947E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#94714B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#936151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9555,
    stopColor: "#934B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923854"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonLogo01);
export default __webpack_public_path__ + "static/media/balloon-logo-01.f20cd6e6a222fc9ed9b2c353d8f7bbf1.svg";
export { ForwardRef as ReactComponent };